<h2 mat-dialog-title>Setup new two-factor authentication method</h2>
<mat-dialog-content>
  @switch (currentStep) {
    <!-- Step 1: Method Selection -->
    @case ('selectMethod') {
      <div>
        <p>Choose an authentication method:</p>
        <ul class="list-unstyled">
          @for (method of availableMethods; track method) {
            <li>
              <button mat-stroked-button [color]="{'accent': method.secure, 'warn': !method.secure}" (click)="selectMethod(method.id)">
                {{ method.name }}
                @if (method.secure) { <span class="text-sm">(Recommended)</span> }
              </button>
            </li>
          }
        </ul>
      </div>
    }
    <!-- Step 2: Verification -->
    @case ('completeRegistration') {
      <div>
        @switch (selectedMethod) {
          <!-- Email OTP -->
          @case (MFAMethodsEnum.EMAIL_OTP) {
            <div>
              <p class="text-lg"><strong>Configure email as your two-factor authentication method</strong></p>
              <form [formGroup]="otpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Enter code from your email</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              <p>{{ errorMessage }}</p>
            </div>
          }
          <!-- TOTP -->
          @case (MFAMethodsEnum.TOTP) {
            <div>
              <p class="text-lg"><strong>Configure your Authenticator App</strong></p>
              @if (qrCodeDataUrl) {
                <div>
                  <p>Scan the QR code with your authenticator app:</p>
                  <img [src]="qrCodeDataUrl" alt="TOTP QR Code" />
                </div>
              }
              @if (secretKey) {
                <div class="copy-text__container">
                  <span class="copy-text__text">{{ secretKey }}</span>
                  <button mat-flat-button (click)="copyToClipboard()" i18n>
              Copy
            </button>
                </div>
              }
              <form [formGroup]="totpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Enter code from authenticator app</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              @if (errorMessage.length > 0) {
                <p role="status" class="box box-danger">{{ errorMessage }}</p>
              }
            </div>
          }
        }
      </div>
    }
  }
</mat-dialog-content>

<!-- Footer Actions -->
<mat-dialog-actions align="end">
  <ul class="list-inline list-unstyled">
    <li>@if (currentStep === 'completeRegistration' && !isPreselectedMethod) {
      <button mat-stroked-button (click)="goBack()">Back</button>
    }</li>
    <li><button mat-stroked-button color="warn" mat-dialog-close (click)="closeDialog()">Cancel</button></li>
    <li>@if (currentStep === 'completeRegistration') {
      <button
        mat-stroked-button
        color="primary"
        [disabled]="isCompleteRegistrationDisabled()"
        (click)="completeRegistration()"
        >
        Verify and complete registration
      </button>
    }</li>
  </ul>
</mat-dialog-actions>
